import { Locale } from "./locale";

export type I18nLabels<T extends string> = Record<T, Record<Locale, string>>;

export function getLabel<T extends string>(
  labels: I18nLabels<T>,
  key: T,
  locale: Locale,
): string {
  return labels[key]?.[locale] ?? labels[key]?.[Locale.ZH_CN] ?? key;
}

export function getLabelsByLocale<T extends string>(
  labels: I18nLabels<T>,
  locale: Locale,
): Record<T, string> {
  const result = {} as Record<T, string>;
  for (const key of Object.keys(labels) as T[]) {
    result[key] = labels[key]?.[locale] ?? labels[key]?.[Locale.ZH_CN] ?? key;
  }
  return result;
}
